import { Button } from "antd";
import { formatDate, CurrencyFormat } from "../../../../../components/helpers";

export const convertPawnTransaction = (pawnTransactions, handleOpenPreview) => {
  let convertedPawnTransactions = [];

  if (!pawnTransactions) return [];

  pawnTransactions.forEach((transaction, index) => {
    convertedPawnTransactions.push({
      key: index + 1,
      dateTime: formatDate(transaction.date_time) || "-",
      transactionID: transaction.transaction_id,
      entityID: transaction.entity_id,
      pawnNumber: transaction.gadai_proof || "-",
      receiptNumber: transaction.receipt_number || "-",
      customerName: transaction.customer_name || "-",
      transactionType: transaction.transaction_type || "-",
      paymentType: transaction.payment_type || "-",
      tenorType: transaction.tenor_type || "-",
      paymentMethod:
        transaction.payment_method === "cash"
          ? "Tunai"
          : transaction.payment_method === "transfer"
          ? "Non-Tunai"
          : "-",
      tenor: `${transaction.tenor} Hari` || "-",
      voucher: `${transaction.voucher}` || "-",
      amount: `Rp ${CurrencyFormat(transaction.amount) || 0}`,
      transactionProof: transaction.transaction_proof ? (
        <Button
          onClick={handleOpenPreview(
            `transaction/${transaction.transaction_id}/transaction-proof-picture`
          )}
          type="link"
          style={{ padding: 0 }}
        >
          Lihat File
        </Button>
      ) : (
        "-"
      ),
    });
  });
  return convertedPawnTransactions;
};

export const convertTransactionTypeCount = (
  transactionTypeList,
  count,
  currentTransactionType = null
) => {
  const total = Object.keys(count).reduce(
    (sum, currentCount) => sum + count[currentCount],
    0
  );

  const convertedCount = transactionTypeList.map((transactionType) => {
    const key = Object.keys(count).find(
      (key) => key.toLowerCase() === transactionType.value
    );
    return {
      ...transactionType,
      count: transactionType.value === "semua" ? total : count[key] || 0,
      active: transactionType.value === currentTransactionType ? true : false,
    };
  });
  return convertedCount;
};
